import {IntermediatePart} from "../intermediatePart";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {mergeFilterObjects} from "../../../../misc/utils";
import store from "../../../../store";
import {hardCodeIsCaesarStone} from "../../../../misc/fabricatorHardcode";

// EDGE features:
//
// Full Bullnose
// Triple Pencil
// Eased
// Half Bullnose
// Quarter Bevel
// Waterfall
// Ogee
//
//
// Ogee Bull
// Pencil
// Bevel Top and Bottom
//
// Caes hardcode - Bevel Top and Bottom - is Quarter Bevel
//
// ========================
//
// Countertop features:
//
const countertopMetaDataValues = ["Full Bullnose", "Triple Pencil", "Eased", "Half Bullnose", "Quarter Bevel",
  "Waterfall", "Ogee"];
//
// Top and Bottom Round


export default class EdgeCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Edge"] || (Array.isArray(dbFeature.metaData["Edge"]) && !dbFeature.metaData["Edge"].length)) {
      const edgeFilterGroup = this.getEdgeFilterGroup();
      const assignedEdgeFilter = this.getEdgeFilterGroupFilters({dbFeature}, edgeFilterGroup);
      dbFeature.metaData["Edge"] = (dbFeature.sharedFeatureName || "").split(" Edge")[0];
      if (Array.isArray(assignedEdgeFilter) && assignedEdgeFilter[0] && edgeFilterGroup && edgeFilterGroup.values) {
        const fValue = edgeFilterGroup.values.find(filter => filter.id === assignedEdgeFilter[0]);
        if (fValue && fValue.value) {
          const metaDataMatchName = fValue.value.split(" Edge")[0];
          if (countertopMetaDataValues.includes(metaDataMatchName)) {
            dbFeature.metaData["Edge"] = metaDataMatchName;
          }
        }
      }
      if (document.kvConfig.isCaesarStone || hardCodeIsCaesarStone()) {
        if (dbFeature.metaData["Edge"] === "Edge Profile – Ogee (Linear Feet)") {
          dbFeature.metaData["Edge"] = "Ogee"
        } else if (dbFeature.metaData["Edge"] === "Bevel Top and Bottom") {
          dbFeature.metaData["Edge"] = "Quarter Bevel"
        }
      }
    }
    return super.load(dbFeature);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    const edgeFilterGroup = this.getEdgeFilterGroup();
    const parentGroup = this.getParent();
    const countertop = parentGroup.countertop;

    // here we check if some countertop has the same name as currently active countertop & it has edge filter
    if (edgeFilterGroup && countertop && countertop.activeFeature) {
      if (this.partId === "center_island_edge" && parentGroup.layout.type === 3) {
        return []
      }
      featuresToDisplay = featuresToDisplay.map((feature) => {
        feature.notAvailableInVisualizer = !(this.getMatchingCounterTop(feature)).matchingFeature;
        return feature
      });
    }

    return featuresToDisplay.map(_ => {
      const featurePart = new DesignNavigationItem(_.featureName, _);
      featurePart.notAvailableInVisualizer = featurePart.part.notAvailableInVisualizer;
      return featurePart
    });
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);  // set active edge feature
    const matchCounterTopObject = this.getMatchingCounterTop();
    console.log("matchCounterTopObject", matchCounterTopObject);
    if (matchCounterTopObject.matchingFeature) {
      matchCounterTopObject.matchingFeature.handleClick(true);
    }
    this.featureClicked();
  }

  /***
   * @returns {object}
   * **/
  getMatchingCounterTop = (feature = this) => {
    const parent = feature.getParent();
    const countertop = parent.getParent().countertop;

    if (!countertop) {
      return {matchingFeature: null, hasSameName: false}
    }

    if (countertop.activeFeature && (countertop.activeFeature.metaData["Edge"] === feature.metaData["Edge"])) {
      return {matchingFeature: countertop.activeFeature, hasSameName: true} // no need to do anything
    }

    let matchingByName = [];
    let matchingFeatures = [];
    const allCountertopFeatures = countertop.features;
    let currentActiveName = countertop.activeFeature ? countertop.activeFeature.getCountertopGroupsSplittedFeatureName() : "";
    for (let i = 0; i < allCountertopFeatures.length; i++) {
      const countertopFeature = allCountertopFeatures[i];
      if (countertopFeature.notAvailableInVisualizer) {
        continue;
      }
      if (countertopFeature.metaData["Edge"] === feature.metaData["Edge"]) {
        matchingFeatures.push(countertopFeature);
        if (currentActiveName && (currentActiveName === countertopFeature.getCountertopGroupsSplittedFeatureName())) {
          matchingByName.push(countertopFeature);
        }
      }
    }
    if (matchingByName.length) {
      return {matchingFeature: matchingByName[0], hasSameName: true}
    }
    return {matchingFeature: matchingFeatures[0] || null, hasSameName: false}
  };

  getEdgeFilterGroupFilters = (feature, edgeFilterGroup) => {
    if (!feature._allEdgeFilters) {
      const allEdgeFilters = mergeFilterObjects(feature.dbFeature.filterValueIDs, feature.dbFeature.fabFilterValueIDs);
      feature._allEdgeFilters = allEdgeFilters && edgeFilterGroup ? allEdgeFilters[edgeFilterGroup.id] : [];
    }
    return feature._allEdgeFilters;
  };

  getMatchingCounterTopFeaturesBySplittedName = (countertop, matchingFeatures = []) => {  // array of sorted by filter features
    if (!countertop.activeFeature) {
      return []
    }
    let currentActiveName = countertop.activeFeature.getCountertopGroupsSplittedFeatureName();
    return matchingFeatures.filter(feature => {
      const currentFeatureName = feature.getCountertopGroupsSplittedFeatureName();
      return currentFeatureName === currentActiveName
    })
  };

  getEdgeFilterGroup = () => {
    const filterGroups = store.getState().filterState.filterGroups;
    return filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
  };

  getArrayOfConditions(forNavigation = false) {
    const countertop = this.getParent().countertop;
    if (!forNavigation && countertop && countertop.activeFeature && countertop.activeFeature.metaData["Edge"]) {
      return [{
        propName: "Edge",
        propValue: countertop.activeFeature.metaData["Edge"]
      }]
    }
    return [];
  }

  canUseNavigationFilterSteps() {
    return true
  }

  setLayers(layout) {
    if (this.activeFeature && (!this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.setDefault(layout);
    }
    return false
  }

  setZIndex() {
    return false
  }

  setEdgeNotInVisualizer = () => {
    // console.log("setEdgeNotInVisualizer", );
    const countertop = this.getParent().countertop;
    const filterGroups = store.getState().filterState.filterGroups;
    const edgeGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
    if (edgeGroup && countertop) {
      Object.keys(this.featuresList).forEach(layoutType => {
        for (let i = 0; i < this.featuresList[layoutType].length; i++) {
          const feature = this.featuresList[layoutType][i];
          if (feature.dbFeature.filterValueIDs[edgeGroup.id]) {
            const edgeValue = feature.dbFeature.filterValueIDs[edgeGroup.id][0];
            const edgeExist = countertop.featuresList[layoutType].some(countertopFeature => {
              return countertopFeature.dbFeature.filterValueIDs[edgeGroup.id]
                && countertopFeature.dbFeature.filterValueIDs[edgeGroup.id].includes(edgeValue)
            });
            if (edgeExist) {
              feature.notAvailableInVisualizer = false
            }
          }
        }
      });
    }
  }

}
